import { render } from "./InlineChoice.vue?vue&type=template&id=c2abcdb6"
import script from "./InlineChoice.vue?vue&type=script&lang=js"
export * from "./InlineChoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__